import { queryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { fetcher } from '@/lib/fetcher'
import { ENDPOINTS } from '@/query-client/endpoints'
import { Config, TermsResponse } from '@/query/config'

export const configQueryOptions = queryOptions<
  API<Config>,
  AxiosError<API>,
  Config | undefined
>({
  queryFn: () => fetcher<Config>(ENDPOINTS.CONFIG.GET_CONFIG, { auth: true }),
  queryKey: ['config'],
  select: (data) => data.data
})

/** Public policy content (no auth). Pass lang for Accept-Language. */
export const getTermsQuery = (lang: 'ar' | 'en') =>
  queryOptions<API<TermsResponse>, AxiosError<API>, TermsResponse | undefined>({
    queryFn: () =>
      fetcher<TermsResponse>(ENDPOINTS.CONFIG.GET_TERMS, {
        auth: false,
        headers: {
          'Accept-Language': lang
        }
      }),
    queryKey: ['terms', lang],
    select: (data) => data.data
  })
